import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconInsertEmoticonComponent } from "./med-icon-insert-emoticon.component";

@NgModule({
  declarations: [
    MedIconInsertEmoticonComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconInsertEmoticonComponent,
  ],
})
export class MedIconInsertEmoticonModule { }
